// @flow
import { connect } from 'react-redux';
import ReferralPromotionDetails from './ReferralPromotionDetails';
import { setGodfatherExternalId } from '../../../../../../modules/SignUp/Bonus/actions';
import { godfatherExternalIdSelector, verifyGodfather } from '../../../../../../modules/SignUp/Bonus/';

const onDelete = () => setGodfatherExternalId(null);

const mapStateToProps = state => ({
  godfatherExternalId: godfatherExternalIdSelector(state),
});

const mapDispatchToProps = {
  onDelete,
  verifyGodfather,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReferralPromotionDetails);
